import { defineMessages } from 'react-intl'

const scope = 'app.containers.EcommerceTablePage'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Ecommerce',
  },
  count: {
    id: `${scope}.count`,
    defaultMessage: 'Ecommerce: {displayed} of {total}',
  },
  filters: {
    id: `${scope}.filters`,
    defaultMessage: 'Filters',
  },
})
